import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatToolbarModule } from '@angular/material/toolbar';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TranslateModule } from '@ngx-translate/core';
import { TermsConditionsDialogComponent } from './terms-conditions-dialog.component';

@NgModule({
    declarations: [TermsConditionsDialogComponent],
    imports: [
        CommonModule,
        MatButtonModule,
        MatDialogModule,
        MatIconModule,
        MatProgressSpinnerModule,
        MatToolbarModule,
        FlexLayoutModule,
        TranslateModule,
    ],
    exports: [TermsConditionsDialogComponent],
})
export class TermsConditionsDialogModule {}
